<template>
  <div class="flex items-center gap-2">
    <CircleCheck v-if="isValid" class="text-green-600" :size="size" />
    <CircleX v-else class="text-red-500" :size="size" />
  </div>
</template>

<script setup lang="ts">
import { CircleCheck, CircleX } from 'lucide-vue-next'

const props = defineProps({
  isValid: {
    type: Boolean,
    required: true,
  },
  size: {
    type: Number,
    default: 16,
  },
})
</script>
